// The % box beside a monthly tax, insurance or MI amount is a yearly rate, the
// way LOs quote them (1.2% a year of the value, not 0.1% a month).

const num = (value) => parseFloat(`${value ?? ""}`.replace(/[$,\s]/g, "")) || 0

/** Yearly % of base that a monthly amount comes to, to 3 decimals; 0 with no base. */
export const annualPctOfBase = (monthly, base) => {
    const b = num(base)
    return b > 0 ? Math.round(((num(monthly) * 12) / b) * 100000) / 1000 : 0
}

/** Monthly dollars, as a string with at most 2 decimals, for a yearly % of base. */
export const monthlyFromAnnualPct = (pct, base) => {
    const cents = Math.round(((num(pct) / 100) * num(base) / 12) * 100)
    return cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2)
}
